import styles from './Me.module.css';

function Me( { openView } ) {
    return (
        <div className={styles.meContainer + " text-center text-shadow-active"}>

            {/* CENTERED INTRO */}
            <div className={styles.meIntro}>
                <h1 className="display-5"><strong>Hi, I'm VOLTAIRE REY JR. UYCOQUE</strong></h1>
                <h6>and</h6>
                <h1 className="display-4">I'm a <b>DEVELOPER</b></h1>
            </div>

            {/* BOTTOM BUTTONS */}
            <div className={styles.meButtons}>
                <button className={styles.btnSweep} onClick={() => openView('corporate')}>
                    <span className={styles.btnText}>[ Corporate ]</span>
                </button>

                <button className={styles.btnSweep} onClick={() => openView('freelance')}>
                    <span className={styles.btnText}>[ Freelance ]</span>
                </button>
                <button className={styles.btnSweep} onClick={() => openView('personal')}>
                    <span className={styles.btnText}>[ Personal ]</span>
                </button>
            </div>
            <div className= { styles.scrollIndicator }>
                <span></span>
                <span></span>
            </div>
        </div>
    );
}

export default Me;